/**
 *
 *  renderCalendarDay Wrapper
 *  TruBe Date Time renderCalendarDay Container Component
 *
 *  Created by Vladimir Shishlyannikov on 28/02/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";
import CalendarDay from "../../CalendarDay/CalendarDay";
import CalendarDayContents from "../../CalendarDayContents/CalendarDayContents";

export default function renderCalendarDayRow(props) {
  const { daySize, focusedInput, ...rest } = props,
    { modifiers } = rest,
    tooltipMessage = false,
    _daySize = daySize || 48;

  return (
    <CalendarDay {...rest}>
      <CalendarDayContents
        {...rest}
        daySize={_daySize}
        modifiers={modifiers}
        tooltipMessage={tooltipMessage || undefined}
      />
    </CalendarDay>
  );
}
